//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import {MInputValueType} from '../Toolkit/Components/Controls/TextArea';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import {Enumeration} from '../Api/ControllerTypes/EnumerationTypes';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import {MNullable} from '../Toolkit/Utils';

//endregion

/** */
type Props = {
    contactTypes: Enumeration[];
}

export type ContactData = {
    contactType: number;
    descriptionText: string;
    valueText: string;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    contactData: ContactData;
    onAddContact?: (data: ContactData) => void;
}

/** */
class ContactDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onValueChange = this.onValueChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            contactData: {contactType: 0,
                descriptionText: '',
                valueText: ''},
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: ContactData) => void, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.onAddContact = inputCallback;
            draft.contactData = {contactType: 0,
                descriptionText: this.props.contactTypes[0].name,
                valueText: ''}
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private async ok_Click() {
        await this.state.onAddContact!(this.state.contactData!);
        this.hide();
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    <MFormControl label={'Contact Type'} id={'ContactTypeField'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MDropDown<number> id="CrewType"
                                                   disabled={false}
                                                   items={this.props.contactTypes.map((enumvalue) => {
                                                       return {label: enumvalue.name, value: enumvalue.id};
                                                   })}
                                                   initialValue={-1}
                                                   onChange={this.onTypeChange}
                                />
                            );
                        }}
                    </MFormControl>
                </div>
                <div className="col-12 md:col-12">
                    <MFormControl label={'Value'} id={'ValueField'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextBox id={'contactValue'}
                                          maxLength={255}
                                          disabled={false}
                                          initialValue={''}
                                          onChange={this.onValueChange}
                                />
                            );
                        }}
                    </MFormControl>
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label={'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private onTypeChange(newValue: MNullable<number>) {
        const valueIndex = this.props.contactTypes.findIndex(ct => ct.id === newValue!)

        this.safeSetState(
            (draft: State) => {
                draft.contactData.contactType = newValue!;
                draft.contactData.descriptionText = this.props.contactTypes[valueIndex].name;
            }
        );
    }

    private onDescriptionChange(newValue: MInputValueType) {
        this.safeSetState(
            (draft: State) => draft.contactData.descriptionText = newValue.toString());
    }

    private onValueChange(newValue: MInputValueType) {
        this.safeSetState(
            (draft: State) => draft.contactData.valueText = newValue.toString());
    }

    private isUploadAvailable() {
        return this.state.contactData.valueText.length > 0;
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Add new contact'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-pencil', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default ContactDialog;
